import { PurchaseIframeBase } from '../PurchaseIframeBase';

export const PurchaseIframeSVOD = PurchaseIframeBase;

export default PurchaseIframeSVOD;
